import { useFlagsStatus } from '@unleash/proxy-client-react'

/**
 * Whether the Unleash client has finished its first fetch. Callers that gate
 * access on a flag need this to tell "not enabled" from "not loaded yet".
 * A fetch error also counts as resolved, so a failing Unleash never leaves the
 * caller waiting forever — the flag simply reads as disabled.
 */
export const useAreFeatureFlagsReady = (): boolean => {
  const { flagsReady, flagsError } = useFlagsStatus()

  return flagsReady || Boolean(flagsError)
}
